module.exports = __webpack_public_path__ + "static/media/dai.6d9cbabe.svg";